export const landing: LandingSetup = {
    background: '/assets/images/background.png',
    illustration: '/assets/images/truck-illustration.png',
    illustrationAlt: 'Banker and coach in front of food truck',
    tagline: 'Welcome to',
    title: 'Innovation Accounting Simulation',
    subtitle: 'AKA Yes, chef!',
    text: `<p>Innovation is unpredictable - but it doesn't have to be. We <u>can</u> make predictions of future revenue and impact.</p>
            <p>In this simulation, you'll play an aspiring chef starting a food truck trying to convince a bank to give you startup funding.</p>
            <p>This training will explain:</p>`,
    point1: {
        icon: '/assets/images/question_mark.svg',
        iconAlt: 'Question mark',
        label: 'Why predictions are usually wrong.',
    },
    point2: {
        icon: '/assets/images/grid_view.svg',
        iconAlt: 'Four blocks forming a square',
        label: 'How to break complex estimates into smaller guesses.',
    },
    point3: {
        icon: '/assets/images/arrow_range.svg',
        iconAlt: 'Arrow pointing left and right',
        label: 'How to estimate using ranges.',
    },
    point4: {
        icon: '/assets/images/bar_chart_4_bars.svg',
        iconAlt: 'Chart',
        label: 'How to use qualitative data to improve estimates.',
    },
    point5: {
        icon: '/assets/images/attach_money.svg',
        iconAlt: 'Dollar sign',
        label: 'How to model growth.',
    },
    registrationTitle: 'Register to play:',
    registrationText: 'You will receive access to all Kromatic resources, news and updates.',
    button: 'Play now!',
};
